<template>
  <div class="RegisterCardStyle">
    <SuccessBase :title="$t(title)" :isShowToLogin="!typeEmail">
      <template #default>
        {{ $t('user.user_check-inbox') }}
      </template>
    </SuccessBase>
  </div>
</template>
<script>
import { SuccessBase } from '@/components/layouts'
export default {
  components: {
    SuccessBase
  },
  data: () => {
    return {
      typeEmail: false
    }
  },
  computed: {
    title() {
      return this.typeEmail
        ? 'user.user_email-has-been-sent-to-check'
        : 'user.user_password-reset-email-has-been-sent'
    }
  },
  created() {
    this.typeEmail = this.$route.query.type === 'email'
  }
}
</script>
